@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use '../host-display-block' as *;
@use '../@shared/alert.mixin' as *;
@use '../@shared/field-control.mixin' as *;
@use '../@shared/form-field.mixin' as *;
@use '../@shared/input-container.mixin' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-field-control;
	@include kol-form-field;
	@include kol-input-container;

	.kol-form-field {
		--border-width: 2px;
		--input-size: 1.5em;

		&__label {
			display: contents;

			&-text {
				display: ruby;
			}
		}

		&__input {
			display: flex;
			flex-direction: column;

			&--orientation-horizontal {
				flex-direction: row;
				flex-wrap: wrap;
				align-items: flex-start;
			}
		}

		&--disabled {
			opacity: unset;
		}
	}

	.kol-input-radio {
		display: flex;
		position: relative;
		min-width: var(--a11y-min-size);
		min-height: var(--a11y-min-size);
		align-items: center;
		justify-content: center;
		cursor: pointer;

		&__input {
			border-style: solid;
			border-radius: 100%;
			display: flex;
			width: var(--input-size);
			min-width: var(--input-size);
			height: var(--input-size);
			min-height: var(--input-size);
			margin: 0;
			padding: 0;
			border-width: var(--border-width);
			appearance: none;
			cursor: pointer;

			&:before {
				border-radius: 100%;
				width: calc(var(--input-size) / 2);
				height: calc(var(--input-size) / 2);
				margin: auto;

				content: '';
			}

			&:checked {
				&:before {
					background-color: #000;

					@media (forced-colors: active) {
						/* Give it a visible background in forced colors mode */
						background-color: selectedItem !important;
					}
				}
			}

			&:disabled {
				opacity: 0.5;
				cursor: not-allowed;
			}
		}

		&--disabled {
			cursor: not-allowed;
		}
	}
}
